import { render, staticRenderFns } from "./action-button.vue?vue&type=template&id=dd6a61d6&scoped=true&"
import script from "./action-button.vue?vue&type=script&lang=js&"
export * from "./action-button.vue?vue&type=script&lang=js&"
import style0 from "./action-button.vue?vue&type=style&index=0&id=dd6a61d6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd6a61d6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/stage-dev3/front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dd6a61d6')) {
      api.createRecord('dd6a61d6', component.options)
    } else {
      api.reload('dd6a61d6', component.options)
    }
    module.hot.accept("./action-button.vue?vue&type=template&id=dd6a61d6&scoped=true&", function () {
      api.rerender('dd6a61d6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/action-button.vue"
export default component.exports